// all layers & styles  used in mapNavigation is declared & defined here

import {Vector as VectorLayer, Tile as TileLayer} from 'ol/layer';
import {Vector as VectorSource, TileWMS} from 'ol/source';
import {Style, Fill, Stroke, Text} from 'ol/style';

const getPolygonStyle = (fill, stroke, strokeWidth, font, fontColor) =>
{
    return new Style({
        fill: new Fill({ color: fill }),
        stroke: new Stroke({ color: stroke, width: strokeWidth }),
        text: new Text({
            font: font,
            fill: new Fill({color: fontColor}),
            stroke: new Stroke({color: 'rgba(255,255,255,1)', width: 2}),
        }),
    });
};

const navLayerStyles = {
    state: getPolygonStyle('rgba(0,0,0,0)', 'rgba(0, 0, 0, 0)', 1.5, `bold 14px times`, '#222'),
    district: getPolygonStyle('rgba(110, 230, 111, 0.02)', 'rgb(191, 93, 0)', 1.5, `bold 14px times`, '#222'),
    municipality: getPolygonStyle('rgba(110, 230, 111, 0.02)', 'rgb(128, 74, 0)', 1.5, `normal 12.5px arial`, '#000'),
    soloMunicipality: getPolygonStyle('rgba(0, 255, 255, 0.04)', 'rgb(110, 230, 111)', 2.5),
};

// this navigationlayers are the admin layers used in MapNavigator
export const navigationLayers = {
    state: new VectorLayer({
        id: 'nav-state',
        visible: true,
        opacity: 0.9,
        source: new VectorSource(),
        style: navLayerStyles.state,
        zIndex: 2.0,
    }),
    district: new VectorLayer({ 
        id: 'nav-district',
        zIndex: 2.1,
        source: new VectorSource(),
        style: navLayerStyles.district,
    }),
    municipality: new VectorLayer({
        id: 'nav-municipality',
        zIndex: 2.2,
        source: new VectorSource(),
        style: navLayerStyles.municipality,
    }),
    soloMunicipality: new VectorLayer({
        id: 'nav-solo-municipality',
        source: new VectorSource(),
        style: navLayerStyles.soloMunicipality,
        zIndex: 2.3,
    }),
};

const getLegendUrl = ({layer, forceLabels=false}) => `http://geoserver.pathway.com.np/geoserver/wms?Service=WMS&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LEGEND_OPTIONS=forceLabels:${forceLabels || 'off'}&LAYER=${layer}`;

export const wardLayer = new TileLayer({
    id: 'ward',
    title: 'Ward Boundary',
    visible: true,
    legendPath: getLegendUrl({layer: 'MEP:ward&RULE=RULE2'}),
    source: new TileWMS({
        url: 'http://geoserver.pathway.com.np/geoserver/MEP/wms',
        hidpi: false,
        params: {
            'VERSION': '1.1.1',
            'LAYERS': 'MEP:ward',
            'CQL_FILTER': 'sddmm=0'
        },
        serverType: 'geoserver'
    })
})
